var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jwtDecode } from "jwt-decode";
var TokenRefreshService = /** @class */ (function () {
    function TokenRefreshService() {
        var _this = this;
        this.refreshTimer = null;
        this.isRefreshing = false;
        this.refreshPromise = null;
        /**
         * Handle page visibility change - refresh token when user returns to app
         */
        this.handleVisibilityChange = function () { return __awaiter(_this, void 0, void 0, function () {
            var tokenInfo, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!document.hidden) return [3 /*break*/, 4];
                        tokenInfo = this.getTokenInfo();
                        if (!(tokenInfo && this.hasValidRefreshToken())) return [3 /*break*/, 4];
                        if (!this.isTokenExpiredOrExpiringSoon(tokenInfo.token, 60)) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        console.log('Page became visible, refreshing token...');
                        return [4 /*yield*/, this.refreshToken()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error('Failed to refresh token on page visibility change:', error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
    }
    /**
     * Extract domain from JWT token
     */
    TokenRefreshService.prototype.extractDomainFromToken = function (token) {
        try {
            var decoded = jwtDecode(token);
            return decoded['x-domain'] || null;
        }
        catch (error) {
            console.error('Error extracting domain from token:', error);
            return null;
        }
    };
    /**
     * Get storage data from localStorage
     */
    TokenRefreshService.prototype.getStorageData = function (keys) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                data = {};
                keys.forEach(function (key) {
                    var value = localStorage.getItem(key);
                    if (value) {
                        data[key] = value;
                    }
                });
                return [2 /*return*/, data];
            });
        });
    };
    /**
     * Check if token is expired or will expire soon (within 5 minutes)
     */
    TokenRefreshService.prototype.isTokenExpiredOrExpiringSoon = function (token, bufferMinutes) {
        if (bufferMinutes === void 0) { bufferMinutes = 5; }
        try {
            var decoded = jwtDecode(token);
            var expirationTime = decoded.exp * 1000; // Convert to milliseconds
            var currentTime = Date.now();
            var bufferTime = bufferMinutes * 60 * 1000; // Convert minutes to milliseconds
            return (expirationTime - currentTime) <= bufferTime;
        }
        catch (error) {
            console.error('Error checking token expiration:', error);
            return true; // If we can't decode, consider it expired
        }
    };
    /**
     * Refresh the token using the refresh token
     */
    TokenRefreshService.prototype.refreshToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var newToken;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isRefreshing && this.refreshPromise) {
                            return [2 /*return*/, this.refreshPromise];
                        }
                        this.isRefreshing = true;
                        this.refreshPromise = this.performTokenRefresh();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, this.refreshPromise];
                    case 2:
                        newToken = _a.sent();
                        return [2 /*return*/, newToken];
                    case 3:
                        this.isRefreshing = false;
                        this.refreshPromise = null;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Perform the actual token refresh
     */
    TokenRefreshService.prototype.performTokenRefresh = function () {
        return __awaiter(this, void 0, void 0, function () {
            var tokenInfo, storageData, subdomain, tokenDomain, domain, response, errorData, data, _a, session_token, refresh_token, user;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        tokenInfo = this.getTokenInfo();
                        if (!tokenInfo) {
                            throw new Error('No token information available');
                        }
                        if (!tokenInfo.refreshToken) {
                            throw new Error('No refresh token available');
                        }
                        return [4 /*yield*/, this.getStorageData(['subdomain'])];
                    case 1:
                        storageData = _b.sent();
                        subdomain = storageData.subdomain;
                        tokenDomain = this.extractDomainFromToken(tokenInfo.token);
                        domain = tokenDomain || subdomain || 'HitWit-public';
                        return [4 /*yield*/, fetch("".concat(process.env.REACT_APP_API_URL, "?action=refresh_session_token&domain_name=").concat(domain), {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify({
                                    refresh_token: tokenInfo.refreshToken
                                })
                            })];
                    case 2:
                        response = _b.sent();
                        if (!!response.ok) return [3 /*break*/, 4];
                        return [4 /*yield*/, response.json().catch(function () { return ({}); })];
                    case 3:
                        errorData = _b.sent();
                        throw new Error(errorData.message || "HTTP ".concat(response.status, ": ").concat(response.statusText));
                    case 4: return [4 /*yield*/, response.json()];
                    case 5:
                        data = _b.sent();
                        if (data.status !== 'ok') {
                            throw new Error(data.message || 'Token refresh failed');
                        }
                        _a = data.response, session_token = _a.session_token, refresh_token = _a.refresh_token, user = _a.user;
                        // Update localStorage with new tokens
                        localStorage.setItem("token", session_token);
                        localStorage.setItem("refresh_token", refresh_token);
                        console.log('Token refreshed successfully');
                        return [2 /*return*/, session_token];
                }
            });
        });
    };
    /**
     * Get current token information from localStorage
     */
    TokenRefreshService.prototype.getTokenInfo = function () {
        var token = localStorage.getItem("token");
        var refreshToken = localStorage.getItem("refresh_token");
        if (!token || !refreshToken) {
            return null;
        }
        try {
            var decoded = jwtDecode(token);
            return {
                token: token,
                refreshToken: refreshToken,
                expiresAt: decoded.exp * 1000 // Convert to milliseconds
            };
        }
        catch (error) {
            console.error('Error decoding token:', error);
            return null;
        }
    };
    /**
     * Check if refresh token is available and valid
     */
    TokenRefreshService.prototype.hasValidRefreshToken = function () {
        var refreshToken = localStorage.getItem("refresh_token");
        return !!refreshToken;
    };
    /**
     * Start automatic token refresh timer
     */
    TokenRefreshService.prototype.startTokenRefreshTimer = function () {
        var _this = this;
        this.stopTokenRefreshTimer(); // Clear any existing timer
        var checkAndRefresh = function () { return __awaiter(_this, void 0, void 0, function () {
            var tokenInfo, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tokenInfo = this.getTokenInfo();
                        if (!tokenInfo) {
                            console.log('No token info available, stopping refresh timer');
                            return [2 /*return*/];
                        }
                        if (!this.isTokenExpiredOrExpiringSoon(tokenInfo.token, 30)) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        console.log('Token expires soon, refreshing...');
                        return [4 /*yield*/, this.refreshToken()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        console.error('Failed to refresh token:', error_2);
                        // If refresh fails, clear tokens and redirect to login
                        this.clearTokens();
                        window.location.href = "/login";
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        // Check immediately
        checkAndRefresh();
        // Set up interval to check every 5 minutes
        this.refreshTimer = setInterval(checkAndRefresh, 5 * 60 * 1000);
    };
    /**
     * Stop the token refresh timer
     */
    TokenRefreshService.prototype.stopTokenRefreshTimer = function () {
        if (this.refreshTimer) {
            clearInterval(this.refreshTimer);
            this.refreshTimer = null;
        }
    };
    /**
     * Clear all tokens from localStorage
     */
    TokenRefreshService.prototype.clearTokens = function () {
        localStorage.removeItem("token");
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("organization");
    };
    /**
     * Initialize token refresh service
     */
    TokenRefreshService.prototype.initialize = function () {
        // Start the refresh timer if we have a valid token
        var tokenInfo = this.getTokenInfo();
        if (tokenInfo && this.hasValidRefreshToken()) {
            this.startTokenRefreshTimer();
        }
        // Add page visibility change listener
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
    };
    /**
     * Cleanup when the service is no longer needed
     */
    TokenRefreshService.prototype.cleanup = function () {
        this.stopTokenRefreshTimer();
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    };
    return TokenRefreshService;
}());
export { TokenRefreshService };
// Create a singleton instance
export var tokenRefreshService = new TokenRefreshService();
